import * as fp from 'lodash/fp';

export default function checkTaxNumber(value: string): boolean {
  const TAX_INVOICE_VALID_MOD = 5;
  const cx = [1, 2, 1, 2, 1, 2, 4, 1];

  const regex = /^[0-9]{8}$/;
  if (!fp.eq(value.length, 8) || !regex.test(value)) {
    return false;
  }

  const invoiceNumArr = value.split('').map((c) => parseInt(c));

  const productSum = cx.map((time, index) => {
    const num = invoiceNumArr[index] * time;
    return fp.gte(num, 10) ? Math.floor(num / 10) + (num % 10) : num;
  });

  if (fp.eq(invoiceNumArr[6], 7)) {
    const sum = fp.sum(productSum) - 10;

    return fp.eq((sum + 1) % TAX_INVOICE_VALID_MOD, 0) || fp.eq(sum % TAX_INVOICE_VALID_MOD, 0);
  }

  return fp.eq(fp.sum(productSum) % TAX_INVOICE_VALID_MOD, 0);
}
